import React from 'react';
import styled from 'styled-components';

const Frame = styled.div`
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 12px;
    border: 1px solid #dedede;
    background: #f7f6fb;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    /* Apply text shadow to all text elements inside the overlay for better visibility */
    & > * {
        text-shadow: 0 1px 3px rgba(0,0,0,0.4);
    }
`;

const OverlayPreviewFrame = ({ overlay, promotion, scale = 1, animated = false }) => {
    if (!overlay) {
        return null;
    }

    const content = animated
        ? overlay.renderAnimated(promotion, scale)
        : overlay.render(promotion, scale);

    return <Frame>{content}</Frame>;
};

export default OverlayPreviewFrame;
